import { Divider } from '@material-ui/core';
import React from 'react';

function FormDivider(props) {
  return (
    <>
      <span className="mb-2 badge badge-primary">{props.title}</span>
      <Divider style={{ marginBottom: 12 }} />
    </>
  );
}

export default FormDivider;
